export const LocalStoreKeys = {
  SWIPE_SDK_CONFIG: 'swipe_SDK_Config',
  LOGGER_CUSTOM_SENDER: 'swipe_logger_custom_sender',
  SELECTED_GAME: 'swipe_selected_game',
  IS_SWIPE_SDK_INITIATED: 'is_swipe_sdk_initiated',
  SHOW_FINE_DATA: 'show_fine_data',
} as const;
